import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

/**
 * Per requirement GP-13, this provides a list of a reallocation's ratios
 */
export const ReallocRatioList = ({ calcObj }) => {
  const augRowsReq = useCallback((rowsReq) => {
    if (!calcObj) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('calcId', calcObj.id));
  }, [calcObj.id]);


  const augFieldDefs = useCallback((fieldToFieldDef) => {
    const columns = ['discPeriod', 'salePeriod', 'reallocDims', 'reallocKey', 'totalDisc', 'totalAmt', 'reallocRatio'];


    Object.keys(fieldToFieldDef).forEach(colName => {
      if (!columns.includes(colName)) {
        delete fieldToFieldDef[colName];
      } else {
        const index = columns.indexOf(colName);
        fieldToFieldDef[colName].precedence = (index + 1) * 100
      }
    });
  });

  //const getContextMenuItems = (params) => {
    //TODO: Add Trx Viewers with v6 ViewerPlugin
  //}


  return (
    <EntityList
      entity="REALLOC_RATIO"
      augRowsReq={augRowsReq}
      augFieldDefs={augFieldDefs}
    />
  )
}